import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private loading!: any; 
  activeElement !: any;
  private globalIndexVariable: any;   //STCAI-234
  constructor(public loadingCtrl: LoadingController) { }


  setGlobalVariable(value: any) {
    this.globalIndexVariable = value;
  }

  getGlobalVariable():any {
    return this.globalIndexVariable;
  }


  showLoading() {
    if (this.loading) {
      this.loading.then((loading: HTMLIonLoadingElement) => {
        loading.dismiss();
      });
    }
    this.activeElement = <HTMLElement> document.activeElement;
    this.activeElement?.blur();
    this.loading = this.loadingCtrl.create({
      message: 'Storing data...',
      spinner: 'circles',
    }).then((loading: HTMLIonLoadingElement) => {
      loading.present();
      return loading;
    });
  }

  logoutLoading() {
    
    if (this.loading) {
      this.loading.then((loading: HTMLIonLoadingElement) => {
        loading.dismiss();
      });
    }
    this.activeElement = <HTMLElement> document.activeElement;
    this.activeElement?.blur();
    this.loading = this.loadingCtrl.create({
      message: 'Loading ...',
      spinner: 'circles',
    }).then((loading: HTMLIonLoadingElement) => {
      loading.present();
      return loading;
    });
  }

  storeDataLoading() {
    
    if (this.loading) {
      this.loading.then((loading: HTMLIonLoadingElement) => {
        loading.dismiss();
      });
    }
    this.activeElement = <HTMLElement> document.activeElement;
    this.activeElement?.blur();
    this.loading = this.loadingCtrl.create({
      message: 'Saving data...',
      spinner: 'circles',
    }).then((loading: HTMLIonLoadingElement) => {
      loading.present();
      return loading;
    });
  }




  dismissLoading() {
  //   if (this.loading) {
  //     await this.loading.dismiss();
  //  }
   if (this.loading) {
    this.loading.then((loading: HTMLIonLoadingElement) => {
      loading.dismiss();
      setTimeout(() => {
        this.activeElement?.focus();
      }, 100);
    });
  }
}
}


